import { render, staticRenderFns } from "./NavBalance.vue?vue&type=template&id=5e87501f&"
import script from "./NavBalance.vue?vue&type=script&lang=js&"
export * from "./NavBalance.vue?vue&type=script&lang=js&"
import style0 from "./NavBalance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports